import React from 'react';
import { BranchFormModal } from '@/pages/branches/list/components/branchFormModal';
import { useCreateBranch } from '@/pages/branches/list/useCreateBranch';
import { PATH } from '@/router/PATH';
import type { ActionSurfaceProps } from '../../controlCenterSurfaces';

/**
 * "Add branch" from the launcher. See `AddBrandSurface` for the shape.
 *
 * The form's "Main branch" switch works from here exactly as it does on the
 * page: the server demotes the previous main in the same transaction, so there
 * is nothing for the launcher to coordinate and nothing it could get wrong.
 */
export const AddBranchSurface: React.FC<ActionSurfaceProps> = ({
    onClose,
    onDone,
}) => {
    const [error, setError] = React.useState<string | null>(null);
    const { create, isCreating } = useCreateBranch();

    return (
        <BranchFormModal
            error={error}
            initialValues={null}
            isOpen
            isSubmitting={isCreating}
            mode="create"
            onClose={onClose}
            onSubmit={async (input) => {
                setError(null);
                const created = await create(input);
                if (!created.ok) {
                    setError(created.message);
                    return;
                }
                onDone({
                    messageKey: 'controlCenter.outcome.branchAdded',
                    messageParams: { name: input.name },
                    to: PATH.BRANCHES.ROOT,
                    linkKey: 'controlCenter.outcome.openBranches',
                });
            }}
        />
    );
};
